import { useCallback, useSyncExternalStore } from 'react';
import { deviceLive } from './stores';
import type { EntityStore, Versioned } from './entityStore';
import type { DeviceLive } from './types';

/**
 * Subscribes a component to ONE entity and re-renders it only when the selected value changes.
 * Select primitives (e.g. d => d?.metrics?.['electrical.power_w']) so unrelated field changes are ignored.
 */
export function useEntity<T extends Versioned, S>(
  store: EntityStore<T>,
  id: string,
  select: (e: T | undefined) => S,
): S {
  const subscribe = useCallback((l: () => void) => store.subscribeKey(id, l), [store, id]);
  return useSyncExternalStore(subscribe, () => select(store.get(id)));
}

export function useDeviceLive<S>(id: string, select: (d: DeviceLive | undefined) => S): S {
  return useEntity(deviceLive, id, select);
}
